import React, { useEffect, useState } from "react";

import { useLocales } from "hooks";

export interface Values {
  comparison: string;
  threshold: number | "";
}

export interface SubscriptionFormProps {
  availableComparisons: string[];
  onCreate: (values: Values) => Promise<void>;
  metricLabel: string;
}
export const SubscriptionForm: React.FC<SubscriptionFormProps> = ({
  availableComparisons,
  onCreate,
  metricLabel,
}) => {
  const { t } = useLocales();

  const [values, setValues] = useState<Values>({
    comparison: availableComparisons[0] || "exceeds",
    threshold: "",
  });
  useEffect(() => {
    if (!availableComparisons.includes(values.comparison)) {
      setValues((values) => ({
        ...values,
        comparison: availableComparisons[0],
      }));
    }
  }, [availableComparisons]);
  const formSetter =
    (field: "comparison" | "threshold") =>
    (
      event:
        | React.ChangeEvent<HTMLSelectElement>
        | React.ChangeEvent<HTMLInputElement>
    ) => {
      setValues((values) => ({ ...values, [field]: event.target.value }));
    };

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    onCreate(values).finally(() => setIsSubmitting(false));
  };

  return (
    <form className="webpush_subscriptions_form" onSubmit={handleSubmit}>
      <div className="form_row">
        <fieldset>
          <label className="control-label" htmlFor="comparison">
            {t("header.comparison")}
          </label>
          <select
            id="comparison"
            className="form-control"
            value={values.comparison}
            onChange={formSetter("comparison")}
            disabled={isSubmitting}
          >
            {availableComparisons.map((comparison) => (
              <option key={comparison} value={comparison}>
                {t(`comparison.${comparison}`)}
              </option>
            ))}
          </select>
        </fieldset>
        <fieldset>
          <label className="control-label" htmlFor="threshold">
            {t("header.threshold")} {metricLabel}
          </label>
          <input
            type="number"
            className="form-control"
            id="threshold"
            placeholder={t("header.threshold")}
            aria-labelledby="threshold"
            aria-required="true"
            required
            value={values.threshold}
            onChange={formSetter("threshold")}
            disabled={isSubmitting}
          />
        </fieldset>
      </div>
      {isSubmitting ? (
        <p>{t("isSubmitting")}</p>
      ) : (
        <button type="submit" className="btn btn-default">
          {t("submit")}
        </button>
      )}
    </form>
  );
};
